import { Injectable } from '@angular/core';
import { MadCloudResult } from '@common/http/models/mad-cloud-result.model';
import { CollectionServiceBase } from '@portal-core/data/collection/services/collection.service.base';
import { DataService } from '@portal-core/data/common/services/data.service';
import { ConnectorLookup } from '@portal-core/publications/models/connector-lookup.model';
import { ConnectorUpdate } from '@portal-core/publications/models/connector-update.model';
import { Connector } from '@portal-core/publications/models/connector.model';
import { ConnectorApiService } from '@portal-core/publications/services/connector-api.service';
import { ConnectorDataService } from '@portal-core/publications/services/connector-data.service';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConnectorService extends CollectionServiceBase<Connector> {
  constructor(
    private connectorApiService: ConnectorApiService,
    private connectorDataService: ConnectorDataService,
    protected dataService: DataService
  ) {
    super(connectorDataService, dataService);
  }

  getLicenseConnectors$(licenseId: number): Observable<Connector[]> {
    return this.connectorApiService.getLicenseConnectors$(licenseId).pipe(
      map(connectors => {
        connectors?.forEach(connector => {
          if (typeof connector?.Settings === 'string') {
            connector.Settings = JSON.parse(connector.Settings);
          }
        });
        return connectors;
      }),
      map(connectors => connectors.sort((connectorA, connectorB) => connectorA.Name.localeCompare(connectorB.Name)))
    );
  }

  getUserConnectors$(licenseId: number): Observable<Connector[]> {
    return this.connectorApiService.getUserConnectors$(licenseId).pipe(
      map(connectors => {
        connectors?.forEach(connector => {
          if (typeof connector?.Settings === 'string') {
            connector.Settings = JSON.parse(connector.Settings);
          }
        });
        return connectors;
      }),
      map(connectors => connectors.sort((connectorA, connectorB) => connectorA.Name.localeCompare(connectorB.Name)))
    );
  }

  deleteConnectors$(connectorIds: number[]): Observable<MadCloudResult> {
    return this.connectorApiService.deleteConnectors$(connectorIds);
  }

  updateConnector$(connector: Partial<ConnectorUpdate>): Observable<MadCloudResult> {
    return this.connectorApiService.updateConnector$(connector);
  }

  createConnector$(connector: Partial<ConnectorUpdate>): Observable<MadCloudResult> {
    return this.connectorApiService.createConnector$(connector);
  }

  getDestinationWithConnector$(projectId: number, branchName: string, filePath: string, allowUserConnectors: boolean) {
    return this.connectorApiService.getDestinationWithConnector$(projectId, branchName, filePath, allowUserConnectors);
  }
}
